module.exports = __webpack_public_path__ + "img/实验室盒子bg.b07b231e.png";